(() => {
  const endAt = Date.parse('2026-08-27T03:59:59Z');
  const root = document.documentElement;

  function isLive() {
    return Date.now() < endAt;
  }

  function two(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function updateCampaignState() {
    const live = isLive();
    root.classList.toggle('wdfix-final-day-live', live);

    document.querySelectorAll('[data-wdfix-final-day]').forEach((element) => {
      element.hidden = !live;
    });

    const remaining = Math.max(0, endAt - Date.now());
    const hours = Math.floor(remaining / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);

    document.querySelectorAll('[data-wdfix-countdown]').forEach((element) => {
      element.textContent = `${two(hours)}:${two(minutes)}:${two(seconds)}`;
      element.setAttribute('aria-label', `${hours} hours, ${minutes} minutes, ${seconds} seconds remaining`);
    });

    const campaignBar = document.querySelector('[data-wdfix-final-day-bar]');
    const campaignSection = campaignBar?.closest('.shopify-section');
    const regularAnnouncement = campaignSection?.nextElementSibling;
    if (regularAnnouncement instanceof HTMLElement) {
      regularAnnouncement.classList.toggle('wdfix-final-day-suppressed', live);
    }

    return live;
  }

  root.classList.toggle('wdfix-final-day-live', isLive());
  updateCampaignState();
  const timer = window.setInterval(() => {
    if (!updateCampaignState()) window.clearInterval(timer);
  }, 1000);

  document.addEventListener(
    'submit',
    async (event) => {
      if (!isLive()) return;
      const form = event.target instanceof HTMLFormElement ? event.target : null;
      if (!form || !form.action.includes('/cart/add')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const submit = form.querySelector('[type="submit"]');
      if (submit instanceof HTMLButtonElement) submit.disabled = true;

      const data = new FormData(form);
      const requested = Math.max(1, Number.parseInt(String(data.get('quantity') || '1'), 10) || 1);
      const campaignKey = `BOGO-${Date.now()}`;
      data.set('quantity', String(requested * 2));
      data.set('properties[_wdfix_final_day]', campaignKey);

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: data,
        });
        if (!response.ok) throw new Error('Cart update failed');

        const added = await response.json();
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          headers: { Accept: 'application/json' },
        });
        const cart = await cartResponse.json();
        const line = cart.items?.find(
          (item) => item.key === added.key || item.properties?._wdfix_final_day === campaignKey
        );
        const hasBogo = line?.discounts?.some((discount) => discount.title === 'WD FIX Final Day BOGO');

        if (!hasBogo && line?.key) {
          await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: requested }),
          });
        }

        window.location.assign('/cart');
      } catch (error) {
        if (submit instanceof HTMLButtonElement) submit.disabled = false;
        window.location.assign('/cart');
      }
    },
    true
  );
})();
